// extracted by mini-css-extract-plugin
export default {"wrapper":"button_wrapper__cQ9Rs","isBtnIcon":"button_isBtnIcon__j9ag8","active":"button_active__1vSEb"};